var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcCameraRedBenefit(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "62px",
    height: "62px",
    viewBox: "0 0 62 62",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icCameraRed") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "path-1",
    cx: 25,
    cy: 25,
    r: 25
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-18.0%",
    y: "-18.0%",
    width: "136.0%",
    height: "136.0%",
    filterUnits: "objectBoundingBox",
    id: "filter-2"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1.5,
    operator: "dilate",
    in: "SourceAlpha",
    result: "shadowSpreadOuter1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 0,
    in: "shadowSpreadOuter1",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.968627451   0 0 0 0 0.419607843   0 0 0 0 0.274509804  0 0 0 0.25 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M14.4571429,9.2 C12.2793714,9.2 10.5142857,10.9658743 10.5142857,13.1428571 C10.5142857,15.3206286 12.2793714,17.0857143 14.4571429,17.0857143 C16.6343886,17.0857143 18.4,15.3206286 18.4,13.1428571 C18.4,10.9658743 16.6343886,9.2 14.4571429,9.2 Z M26.0228571,4.3125 L22.5531429,4.3125 C22.0760571,4.3125 21.5619611,3.9445 21.4113177,3.494275 L20.5143966,0.8179375 C20.3631749,0.368 19.8496571,0 19.3725714,0 L9.54171429,0 C9.06462857,0 8.55053257,0.368 8.39988914,0.818225 L7.502968,3.4945625 C7.35174629,3.9445 6.83822857,4.3125 6.36114286,4.3125 L2.89142857,4.3125 C1.30114286,4.3125 0,5.60625 0,7.1875 L0,20.125 C0,21.70625 1.30114286,23 2.89142857,23 L26.0228571,23 C27.6131429,23 28.9142857,21.70625 28.9142857,20.125 L28.9142857,7.1875 C28.9142857,5.60625 27.6131429,4.3125 26.0228571,4.3125 Z M14.4571429,20.3714286 C10.4649474,20.3714286 7.22857143,17.1350526 7.22857143,13.1428571 C7.22857143,9.15095086 10.4649474,5.91428571 14.4571429,5.91428571 C18.44876,5.91428571 21.6857143,9.15095086 21.6857143,13.1428571 C21.6857143,17.1350526 18.44876,20.3714286 14.4571429,20.3714286 Z M25.3,9.2 C24.7558857,9.2 24.3142857,8.75896327 24.3142857,8.21428571 C24.3142857,7.67017143 24.7558857,7.22857143 25.3,7.22857143 C25.8446776,7.22857143 26.2857143,7.67017143 26.2857143,8.21428571 C26.2857143,8.75896327 25.8443959,9.2 25.3,9.2 Z",
    id: "path-3"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mobile-JS",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "RedHotPie-Premium+-upgrade",
    transform: "translate(-9.000000, -417.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-18",
    transform: "translate(0.000000, 200.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-8"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(0.000000, 202.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icCameraRed",
    transform: "translate(15.000000, 21.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Oval"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-2)",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "colour/dark-grey",
    transform: "translate(11.000000, 13.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#F76B46",
    fillRule: "nonzero",
    xlinkHref: "#path-3"
  })))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCameraRedBenefit);
export default __webpack_public_path__ + "static/media/icCameraRedBenefit.5a453003551cb58898f1653a08c12db5.svg";
export { ForwardRef as ReactComponent };